<template>
  <d-dropdown trap-focus>
    <d-icon slot="activator" icon="filter" class="text-black mr-5 p-2 bg-transparent" size="lg" />
    <div style="width:300px" class="py-3 px-5">
      <d-field label="Filter By">
        <d-input v-model="newValue" class="mb-2" :placeholder="placeholder" />
      </d-field>
    </div>
  </d-dropdown>
</template>

<script>
  import debounce from 'lodash/debounce';

  export default {
    parent: true,
    props: {
      value: String,
      placeholder: {
        type: String,
        default: 'Type to search...',
      },
    },

    data() {
      return {
        newValue: this.value,
      };
    },

    watch: {
      newValue(val) {
        this.debounceValue(val);
      },
    },

    methods: {
      // eslint-disable-next-line
      debounceValue: debounce(function(val) {
        this.$emit('input', val);
      }, 300),
    },
  };
</script>